// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { savedOrderDetailsOrderInformationStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation";
import { styledBoxStyle } from "@keller/App/Components/Common/StyledBox";
import xOrderInformationStyles from "@keller/App/SharedStyle/MyAccount/Details/OrderInformationStyles";
import { css } from "styled-components";

savedOrderDetailsOrderInformationStyles.mainInformationGridItem = {
    width: 12,
    css: css`
        ${xOrderInformationStyles.headingAndTextStyles?.wrapper?.css}
    `,
};

savedOrderDetailsOrderInformationStyles.orderDateTitle = {
    ...xOrderInformationStyles.headingAndTextStyles?.heading,
};

savedOrderDetailsOrderInformationStyles.orderDateText = {
    ...xOrderInformationStyles.headingAndTextStyles?.text,
};

savedOrderDetailsOrderInformationStyles.shippingAddressTitle = {
    ...xOrderInformationStyles.address?.heading,
};

savedOrderDetailsOrderInformationStyles.billingAddressTitle = {
    ...xOrderInformationStyles.address?.heading,
};

savedOrderDetailsOrderInformationStyles.shippingInformationGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
        address {
            width: 100%;
            border-radius: 4px;
            margin-bottom: 10px;
            ${styledBoxStyle}
        }
    `,
};

savedOrderDetailsOrderInformationStyles.billingInformationGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
        address {
            width: 100%;
            border-radius: 4px;
            margin-bottom: 10px;
            ${styledBoxStyle}
        }
    `,
};
